"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Risk API
 * Risk Service API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskToJSON = exports.RiskFromJSONTyped = exports.RiskFromJSON = exports.instanceOfRisk = void 0;
var runtime_1 = require("../runtime");
var AssetImportance_1 = require("./AssetImportance");
var AssetType_1 = require("./AssetType");
var Management_1 = require("./Management");
var Resolution_1 = require("./Resolution");
var RiskCVE_1 = require("./RiskCVE");
var RiskDevice_1 = require("./RiskDevice");
var ScanType_1 = require("./ScanType");
var Severity_1 = require("./Severity");
var Source_1 = require("./Source");
var Status_1 = require("./Status");
/**
 * Check if a given object implements the Risk interface.
 */
function instanceOfRisk(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "assetID" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "assetName" in value;
    isInstance = isInstance && "issueID" in value;
    isInstance = isInstance && "scanType" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "score" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "management" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "firstDetectedTime" in value;
    isInstance = isInstance && "firstDetectedScanID" in value;
    isInstance = isInstance && "lastDetectedTime" in value;
    isInstance = isInstance && "lastDetectedScanID" in value;
    isInstance = isInstance && "issuePublishTime" in value;
    isInstance = isInstance && "issueUpdateTime" in value;
    isInstance = isInstance && "cisaKnownExploit" in value;
    return isInstance;
}
exports.instanceOfRisk = instanceOfRisk;
function RiskFromJSON(json) {
    return RiskFromJSONTyped(json, false);
}
exports.RiskFromJSON = RiskFromJSON;
function RiskFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'assetID': json['assetID'],
        'assetType': (0, AssetType_1.AssetTypeFromJSON)(json['assetType']),
        'assetName': json['assetName'],
        'assetImportance': !(0, runtime_1.exists)(json, 'assetImportance') ? undefined : (0, AssetImportance_1.AssetImportanceFromJSON)(json['assetImportance']),
        'assetModifiedTime': !(0, runtime_1.exists)(json, 'assetModifiedTime') ? undefined : (json['assetModifiedTime'] === null ? null : new Date(json['assetModifiedTime'])),
        'device': !(0, runtime_1.exists)(json, 'device') ? undefined : (0, RiskDevice_1.RiskDeviceFromJSON)(json['device']),
        'issueID': json['issueID'],
        'scanType': (0, ScanType_1.ScanTypeFromJSON)(json['scanType']),
        'source': (0, Source_1.SourceFromJSON)(json['source']),
        'name': json['name'],
        'description': json['description'],
        'recommendations': !(0, runtime_1.exists)(json, 'recommendations') ? undefined : json['recommendations'],
        'references': !(0, runtime_1.exists)(json, 'references') ? undefined : json['references'],
        'score': json['score'],
        'severity': (0, Severity_1.SeverityFromJSON)(json['severity']),
        'cve': !(0, runtime_1.exists)(json, 'cve') ? undefined : (0, RiskCVE_1.RiskCVEFromJSON)(json['cve']),
        'management': (0, Management_1.ManagementFromJSON)(json['management']),
        'status': (0, Status_1.StatusFromJSON)(json['status']),
        'resolution': !(0, runtime_1.exists)(json, 'resolution') ? undefined : (0, Resolution_1.ResolutionFromJSON)(json['resolution']),
        'firstDetectedTime': (new Date(json['firstDetectedTime'])),
        'firstDetectedScanID': json['firstDetectedScanID'],
        'lastDetectedTime': (new Date(json['lastDetectedTime'])),
        'lastDetectedScanID': json['lastDetectedScanID'],
        'lastIndeterminateTime': !(0, runtime_1.exists)(json, 'lastIndeterminateTime') ? undefined : (json['lastIndeterminateTime'] === null ? null : new Date(json['lastIndeterminateTime'])),
        'lastIndeterminateScanID': !(0, runtime_1.exists)(json, 'lastIndeterminateScanID') ? undefined : json['lastIndeterminateScanID'],
        'issuePublishTime': (new Date(json['issuePublishTime'])),
        'issueUpdateTime': (new Date(json['issueUpdateTime'])),
        'cisaKnownExploit': json['cisaKnownExploit'],
    };
}
exports.RiskFromJSONTyped = RiskFromJSONTyped;
function RiskToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'assetID': value.assetID,
        'assetType': (0, AssetType_1.AssetTypeToJSON)(value.assetType),
        'assetName': value.assetName,
        'assetImportance': (0, AssetImportance_1.AssetImportanceToJSON)(value.assetImportance),
        'assetModifiedTime': value.assetModifiedTime === undefined ? undefined : (value.assetModifiedTime === null ? null : value.assetModifiedTime.toISOString()),
        'device': (0, RiskDevice_1.RiskDeviceToJSON)(value.device),
        'issueID': value.issueID,
        'scanType': (0, ScanType_1.ScanTypeToJSON)(value.scanType),
        'source': (0, Source_1.SourceToJSON)(value.source),
        'name': value.name,
        'description': value.description,
        'recommendations': value.recommendations,
        'references': value.references,
        'score': value.score,
        'severity': (0, Severity_1.SeverityToJSON)(value.severity),
        'cve': (0, RiskCVE_1.RiskCVEToJSON)(value.cve),
        'management': (0, Management_1.ManagementToJSON)(value.management),
        'status': (0, Status_1.StatusToJSON)(value.status),
        'resolution': (0, Resolution_1.ResolutionToJSON)(value.resolution),
        'firstDetectedTime': (value.firstDetectedTime.toISOString()),
        'firstDetectedScanID': value.firstDetectedScanID,
        'lastDetectedTime': (value.lastDetectedTime.toISOString()),
        'lastDetectedScanID': value.lastDetectedScanID,
        'lastIndeterminateTime': value.lastIndeterminateTime === undefined ? undefined : (value.lastIndeterminateTime === null ? null : value.lastIndeterminateTime.toISOString()),
        'lastIndeterminateScanID': value.lastIndeterminateScanID,
        'issuePublishTime': (value.issuePublishTime.toISOString()),
        'issueUpdateTime': (value.issueUpdateTime.toISOString()),
        'cisaKnownExploit': value.cisaKnownExploit,
    };
}
exports.RiskToJSON = RiskToJSON;
